
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[descriptor]/plan",
      function () {
        return require("private-next-pages/s/[descriptor]/plan.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[descriptor]/plan"])
      });
    }
  